<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">
    <!--<div class="card-header wh-header card-title-schedule-bb card-title-schedule-bl padding-l-8px  padding-bottom padding-top-5">
      Services Configuration
    </div>-->



  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row">

      <div class="position-fixed-service border-right2 padding-right-0px">
        <div class="card">

          <div class="card-header wh-header header3 padding-right-32px bk-color-light">
            <div class="row margin-top10px margin-left-20px card-title-schedule-bb nav-link-hand" (click)="BackToServices()">
             
              <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                Services SetUp</label>
                <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                    *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>
             
            </div>
            <div class="row margin-left-zero margin-top-10">
              Categories
            </div>



          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-bottom-0px">
            <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left16px">
              <div class="col-md-10 padding-right-0px padding-left-0px margin-left-17px">
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              </div>
              <div class="col-md-2" hidden>
                <button type="button" (click)="AddCategory()" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a (click)="EditCategory()" class="nav-link-hand education-navlink" tooltip="Edit">
                  <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                </a>

              </div>
              <div class="col-md-1 padding-left-8px" hidden>
                <a class="nav-link-hand education-navlink" tooltip="Delete">
                  <span class="badge font-size-14">
                    <i class="far fa-trash-alt"></i>
                  </span>
                </a>
              </div>

            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-width-service agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                <div class="row border-bottom rowfor margin-left16px nav-link-hand" (click)="viewservice(l)" *ngFor="let l of pdata">
                  <div class="col-md-12">

                    <a class="nav-link-hand margin-left-5px">{{l.CategoryName}}</a>


                  </div>

                </div>
              </div>
            </div>

          </div>
          
        </div>
      </div>
      <div class="offset-md-2 col-md-10 padding-left-42px" *ngIf="ShowService">
        <div class="card">

        </div>
        <div class="row" *ngIf="SelectedCategory">
          <div class="col-md-12 padding-left-0px">
            <div class="card">
              <div class="card-header wh-header border-bottom ">
                <div class="row">
                  <div class="col-md-2 padding-right-0px"><label class="label-size-2 font-color-secondary">Selected Category</label></div>:
                  <div class="col-md-3 text-align-left"><label class="label-size-2">{{SelectedCategory.CategoryName}}<!--<a *ngIf="pdata2">({{pdata2.length}})</a>--></label></div>
                  <div class="col-md-6 padding-left-0px">
                    <div class="row margin-left-zero margin-right-0px">

                      <div class="col-md-3 margin-left-auto padding-right-0px">
                        <button type="button" (click)="AddService()" class="btn btn-primary btn-sm margin-right-10px" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                        <button type="button" (click)="gotoservice()" class="btn  btn-detail btn-sm" hidden><i class="fas fa-list nav-link-hand"></i></button>
                      </div>
                      <!--<div class="col-md-1 margin-left-auto padding-right-0px">

                  </div>-->
                      <div class="col-md-4 padding-right-0px padding-left-0px margin-right-8p">
                        <div class="row">
                          <div class="col-md-9 padding-right-0px">
                            <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange2($event)"></search-list>
                          </div>
                          <div class="col-md-1 padding-left-6px">
                            <a *ngIf="pdata2"><div class="badge badge-search"><label class="margin-bottom-4px margin-top-4px">{{pdata2.length}}</label></div></a>
                          </div>
                        </div>
                       
                      </div>
                      <!--<div class="col-md-1">
                        <label class="label-size-2"><a *ngIf="pdata2"><span class="badge">({{pdata2.length}})</span></a></label>
                      </div>-->
                    </div>
                  </div>

                </div>
              </div>
              <div class="card-body">
                <div class="table-component">
                  <div class="table-responsive overflow-x-hidden">


                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr>
                          <th class="td-width-3px">Code</th>

                          <th class="">Name</th>

                          <th class="td-width-3px">Commission </th>
                          <th class="td-width-3px">Discount</th>



                          <th class="td-width-3px">Refund</th>
                          <th class="">Edit Aprvl </th>
                          <th class="">Base Price</th>
                        </tr>
                      </thead>
                      <tbody class="table-body">
                        <tr *ngFor="let l of pdata2">
                          <td><a (click)="ViewServiceDetails(l)" class="nav-link-hand table-anchor">{{l.Code}}</a></td>
                          <td><a (click)="ViewServiceDetails(l)" class="nav-link-hand table-anchor">{{l.ServiceName}}</a></td>


                          <td class="text-align-center">

                            <label class="switch">
                              <input type="checkbox"
                                     [(ngModel)]="l.CommissionAllowed">
                              <span class="slider round"></span>
                            </label>
                            <!--<input type="checkbox" class="margin-left-38px"/>

                        <i class="input-helper"></i>-->

                          </td>
                          <td class="text-align-center">

                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="l.DiscountAllowed">
                              <span class="slider round"></span>
                            </label>
                          </td>
                          <td class="text-align-center">

                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="l.RefundAllowed">
                              <span class="slider round"></span>
                            </label>

                          </td>
                          <td>

                            <label class="switch">
                              <input type="checkbox" [(ngModel)]="l.EditApprovalREquired">
                              <span class="slider round"></span>
                            </label>

                          </td>


                          <td class="text-align-center">

                            {{l.BasePrice}}

                          </td>





                        </tr>

                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     
      <div class="offset-md-2 col-md-12 padding-left-42px">

        <serviceconfig [ServiceCode]='SelectedService.Code' [ServiceName]='SelectedService.ServiceName'
                       [ShowService]='ShowService'
                       *ngIf="SelectedService"></serviceconfig>
      </div>

      <!--<div class="row" *ngIf="SelectedService">

  TESTING  {{SelectedService.Code}}
  </div>-->



    </div>
      </div>

    </div>


